module.exports = __webpack_public_path__ + "img/Villa_Borna_54.932a4286.jpg";